export interface FaqItem {
  readonly question: string;
  readonly answer: string;
}

export const FAQ_ITEMS: readonly FaqItem[] = [
  {
    question: 'Was ist Bubble Soccer?',
    answer:
      'Bubble Soccer ist ein einzigartiger und spassiger Sport, bei dem die Spieler in großen aufblasbaren Bällen (Bubbles) Fußball spielen. Diese Bubbles bedecken den Oberkörper und schützen den Spieler, während er versucht, Tore zu schießen und anderen Spielern auszuweichen.',
  },
  {
    question: 'Ist Bubble Soccer sicher?',
    answer:
      'Ja, Bubble Soccer ist sicher, solange die Spielregeln beachtet werden. Die Bubbles bieten Schutz und dämpfen Stösse ab. Trotzdem ist Vorsicht geboten, insbesondere bei der Wahl des Spielfelds, das frei von Hindernissen und scharfen Gegenständen sein sollte.',
  },
  {
    question: 'Wo kann man Bubble Soccer spielen?',
    answer:
      'Unsere Betreuten-Events finden auf der Sportanlage Rheinauen statt. Auf Anfrage können wir auch zu anderen geeigneten Orten kommen. Bei der Unbetreuten-Option organisierst du den Platz selbst.',
  },
  {
    question: 'Für wen ist Bubble Soccer geeignet?',
    answer:
      'Bubble Soccer ist für Kinder, Jugendliche und Erwachsene geeignet. Wir bieten spezielle Bubbles für Kinder und grössere für Erwachsene an.',
  },
  {
    question: 'Wieviele Personen können spielen?',
    answer:
      'Für ein gelungenes Spiel empfehlen wir mindestens 6 Personen. Gegen oben ist die Anzahl unlimitiert. Wir haben aber maximal 24 Bubbles die wir vermieten können.',
  },
  {
    question: 'Wie läuft der Buchungsprozess ab?',
    answer:
      'Du kannst deinen Termin online über unser Buchungsformular oder telefonisch/WhatsApp anfragen. Wir prüfen ob wir dann Kapazitäten haben und melden uns bei dir.',
  },
  {
    question: 'Wie hole ich die Bubbles ab, und wie funktioniert der Transport?',
    answer:
      'Bei Unbetreut holst du die Bubbles einen Tag vor dem Event bei uns in Diepoldsau ab. Für grosse Bubbles ist ein SUV oder Van ideal. Vereinbare mit uns einen Abholtermin.',
  },
  {
    question: 'Wie bereite ich den Spielplatz vor?',
    answer:
      'Der Platz sollte frei von scharfen Gegenständen wie Steinen oder Ästen sein und genug Raum bieten, um Kollisionen ohne Gefahr zu ermöglichen. Ein Elektroanschluss für die Pumpe ist notwendig, um die Bubbles aufzupumpen.',
  },
  {
    question: 'Was passiert bei schlechtem Wetter?',
    answer:
      'Bei Regen oder extremem Wetter können Events verschoben werden. Kontaktiere uns, um die Möglichkeiten zu besprechen. Wir bemühen uns, eine flexible Lösung zu finden.',
  },
  {
    question: 'Kann ich meine Buchung stornieren oder verschieben?',
    answer: 'Ja, du kannst deine Buchung stornieren oder verschieben. Bis 24h vor dem Event ist dies kostenlos.',
  },
  {
    question: 'Welche Zahlungsmethoden akzeptiert ihr?',
    answer:
      'Nach der Durchführung des Events schicken wir dir eine Rechnung, die du via Banküberweisung begleichen kannst.',
  },
];
